<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="course-content-editor-container">
        <div
          class="close-button absolute cursor-pointer"
          title="Close (Esc)"
          @click="$emit('CLOSE_MODAL')"
        >
          ❌
        </div>
        <div class="row">
          <div class="small-12 columns"><h3>Assignment Stitcher</h3></div>
          <div style="padding-bottom:20px;">Select Assignment</div>
          <div class="small-12 columns" style="padding-bottom:20px;">
            <Multiselect
              v-model="selectedAssignment"
              :options="assignments"
              label="name"
              @search-change="updateList"
            />
          </div>
          <!--  -->
          <div>Is Dependent Topic</div>
          <div class="small-12 columns" style="padding-bottom:20px;">
            <Multiselect
              v-model="is_dependent_topic"
              :multiple="false"
              :options="topics"
              label="name"
            />
          </div>
          <!--  -->
          <div class="small-12 columns">
            <button
              class="px-4 py-2 border border-green bg-green text-white"
              @click="updateAssignment"
            >
              Add Assignment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    Multiselect,
  },
  props: ["topics"],
  data() {
    return {
      is_dependent_topic: undefined,
      assignments: [],
      selectedAssignment: undefined,
      topicList: [],
    }
  },
  mounted() {
    this.updateList()
    this.topicList = this.topics.map(item => ({ name: item.name, id: item.id }))
  },
  methods: {
    updateList(searchText) {
      if (searchText && searchText.length) {
        this.axios({
          method: "get",
          url: `${siteConfig.siteURL}assignments/?search=${searchText}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        }).then(res => {
          this.assignments = res.data.items
        })
      }
    },
    updateAssignment() {
      if (!this.is_dependent_topic) {
        this.$swal({
          icon: "error",
          text: "assignment needs to have a dependent topic",
        })
        throw new Error("assignment needs to have a dependent topic")
      }
      const payload = {
        assignment: this.selectedAssignment,
        is_dependent_id: this.is_dependent_topic.id,
      }
      this.$emit("ASSIGNMENT_ADDED", payload)
    },
  },
}
</script>
